module.exports = __webpack_public_path__ + "static/ficosec-abecd305c2767ba0136d65792316545b.jpg";